import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedesSociales {
  private redesSocialesApiUrl = `${environment.apiUrl}/redes-sociales`;
  constructor(private http: HttpClient) {}

  crearRedesSociales(redesSociales: any): Observable<any> {
    return this.http.post<any>(this.redesSocialesApiUrl, redesSociales);
  }

  obtenerRedesSociales(): Observable<any[]> {
    return this.http.get<any[]>(this.redesSocialesApiUrl);
  }

  actualizarRedesSociales(idRedesSociales: string, redesSociales: any): Observable<any> {
    return this.http.patch<any>(`${this.redesSocialesApiUrl}/${idRedesSociales}`, redesSociales);
  }

  eliminarRedesSociales(id: string): Observable<any> {
    return this.http.delete<any>(`${this.redesSocialesApiUrl}/${id}`);
  }
}
